<template>
	<svg class="animated_success" width="120" height="120" viewBox="0 0 120 120" aria-hidden="true">
		<circle cx="60" cy="60" r="52" fill="#EAF7F0" />
		<circle
			class="animated_success_ring"
			cx="60"
			cy="60"
			r="52"
			fill="none"
			stroke="#00A55A"
			stroke-width="5"
			stroke-linecap="round"
			stroke-dasharray="327"
			stroke-dashoffset="327"
			transform="rotate(-90 60 60)"
		/>
		<path
			class="animated_success_tick"
			d="M38 62l15 15 29-34"
			fill="none"
			stroke="#00A55A"
			stroke-width="7"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-dasharray="70"
			stroke-dashoffset="70"
		/>
	</svg>
</template>

<style lang="scss">
.animated_success {
  color: #00a55a;
}

.animated_success_ring {
  animation: lps-ring 0.7s ease forwards;
}

.animated_success_tick {
  animation: lps-tick 0.5s 0.45s ease forwards;
}

@keyframes lps-ring {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes lps-tick {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
